const ActivitySortFieldEnumType = {
  name: 'NAME',
  createdAt: 'CREATED_AT',
  updatedAt: 'UPDATED_AT'
};

export { ActivitySortFieldEnumType };
export default ActivitySortFieldEnumType;
